import { styled } from '@mui/material'
import { color } from 'config/color'
import type React from 'react'

interface SkipLinkProps {
  targetId: string
  children: React.ReactNode
}

export const SkipLink: React.FC<SkipLinkProps> = ({ targetId, children }) => {
  const handleSkip = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    e.preventDefault()
    const target = document.getElementById(targetId)
    if (target != null) {
      target.focus()
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <StyledSkipLink
      href={`#${targetId}`}
      onClick={handleSkip}
    >
      {children}
    </StyledSkipLink>
  )
}

const StyledSkipLink = styled('a')({
  position: 'absolute',
  left: '-9999px',
  top: '8px',
  zIndex: 9999,
  padding: '12px 16px',
  backgroundColor: color.background[900],
  color: color.white,
  textDecoration: 'none',
  borderRadius: '4px',
  fontWeight: 600,
  fontSize: '14px',

  '&:focus': {
    left: '8px',
    outline: `3px solid ${color.primary[300]}`,
    outlineOffset: '2px'
  },

  '&:hover': {
    backgroundColor: color.primary[700]
  }
})
